/* ═══════════════════════════════════════════════════════
   compat-filter.js
   Collection page compatibility filter — desktop + mobile
   Requires: machine-catalog.js then machines.js
   (MACHINES + evaluateAttachmentCompat)
   ═══════════════════════════════════════════════════════ */
(function() {
  'use strict';

  var STORAGE_KEY = 'sss_machine';
  var state = { type: null, make: null, model: null, specs: null, name: null, on: false, flow: 'standard' };
  var closeDesktopDialog = function() {};
  var closeMobileSheet = function() {};

  function num(v) {
    if (v == null || v === '') return null;
    var n = parseFloat(v);
    return isNaN(n) ? null : n;
  }

  function checkCompat(att, mach, machType) {
    if (typeof evaluateAttachmentCompat === 'function') {
      return evaluateAttachmentCompat(machType, mach, {
        flowMin: att.flowMin,
        flowMax: att.flowMax,
        psiMax: att.psiReq,
        weight: att.weight,
        coupler: att.mount,
        carrierMin: att.carrierMin,
        carrierMax: att.carrierMax,
        machineTypes: att.machineTypes,
        ptoMin: att.ptoMin,
        ptoMax: att.ptoMax,
        hitchMin: att.hitchMin,
        hitchMax: att.hitchMax,
        extraText: att.title || '',
        productTitle: att.title || ''
      }, {
        flowMode: state.flow || 'standard',
        rigid: att.cls !== 'hydraulic',
        machineName: ((state.make || '') + ' ' + (state.model || '')).trim()
      });
    }
    return { r: 'warn', notes: ['Compatibility engine not loaded'] };
  }

  function getProductsFromDOM() {
    var cards = document.querySelectorAll('[data-cf-product]');
    var products = [];
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var types = card.getAttribute('data-cf-types') || '';
      products.push({
        el: card,
        item: card.closest('li') || card,
        id: card.getAttribute('data-cf-product'),
        title: card.getAttribute('data-cf-title') || '',
        cat: card.getAttribute('data-cf-category') || '',
        vendor: card.getAttribute('data-cf-vendor') || '',
        cls: card.getAttribute('data-cf-class') || 'rigid',
        mount: card.getAttribute('data-cf-mount') || '',
        pin: card.getAttribute('data-cf-pin') || null,
        carrierMin: num(card.getAttribute('data-cf-carrier-min')),
        carrierMax: num(card.getAttribute('data-cf-carrier-max')),
        flowMin: num(card.getAttribute('data-cf-flow-min')),
        flowMax: num(card.getAttribute('data-cf-flow-max')),
        psiReq: num(card.getAttribute('data-cf-psi-req')),
        weight: num(card.getAttribute('data-cf-weight')),
        ptoMin: num(card.getAttribute('data-cf-pto-min')),
        ptoMax: num(card.getAttribute('data-cf-pto-max')),
        hitchMin: num(card.getAttribute('data-cf-hitch-min')),
        hitchMax: num(card.getAttribute('data-cf-hitch-max')),
        machineTypes: types ? types.split(',').map(function(x) { return x.trim(); }).filter(Boolean) : []
      });
    }
    return products;
  }

  function saveState() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        type: state.type,
        make: state.make,
        model: state.model,
        flow: state.flow || 'standard'
      }));
    } catch (e) {}
  }

  function loadState() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    } catch (e) { return null; }
  }

  function clearState() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  function lookupSpecs(type, make, model) {
    if (!type || !make || !model || typeof MACHINES === 'undefined') return null;
    if (!MACHINES[type] || !MACHINES[type].makes[make]) return null;
    return MACHINES[type].makes[make][model] || null;
  }

  function populateMakes(typeVal, makeSelect) {
    makeSelect.innerHTML = '<option value="">Select make</option>';
    if (!typeVal || !MACHINES[typeVal]) return;
    Object.keys(MACHINES[typeVal].makes).sort().forEach(function(m) {
      makeSelect.insertAdjacentHTML('beforeend', '<option value="' + m.replace(/"/g, '&quot;') + '">' + m + '</option>');
    });
  }

  function populateModels(typeVal, makeVal, modelSelect) {
    modelSelect.innerHTML = '<option value="">Select model</option>';
    if (!typeVal || !makeVal || !MACHINES[typeVal] || !MACHINES[typeVal].makes[makeVal]) return;
    Object.keys(MACHINES[typeVal].makes[makeVal]).sort().forEach(function(m) {
      modelSelect.insertAdjacentHTML('beforeend', '<option value="' + m.replace(/"/g, '&quot;') + '">' + m + '</option>');
    });
  }

  function setDisabled(sel, dis) {
    if (!sel) return;
    sel.disabled = dis;
    if (sel.parentElement) sel.parentElement.classList.toggle('is-disabled', dis);
  }

  function machineChipsHTML(s, type) {
    var isTr = type === 'tractor';
    var mount = isTr ? ('Cat ' + (s.hitch || '1–2')) : (s.coupler || '');
    var c = mount ? '<span class="cf-chip mount">' + mount + '</span>' : '';
    var cw = (typeof machineCarrierWeight === 'function') ? machineCarrierWeight(type, s) : { lbs: s.capacity };
    if (cw && cw.lbs) c += '<span class="cf-chip">' + cw.lbs.toLocaleString() + ' lb' + (cw.estimated ? ' est.' : '') + '</span>';
    if (!isTr && s.flowMin) {
      c += '<span class="cf-chip">' + s.flowMin + (s.flowMax && s.flowMax !== s.flowMin ? '–' + s.flowMax : '') + ' GPM</span>';
    }
    if (!isTr && s.hfFlowMin) c += '<span class="cf-chip">HF ' + s.hfFlowMin + '–' + s.hfFlowMax + '</span>';
    if (isTr && s.auxFlowMin) c += '<span class="cf-chip">' + s.auxFlowMin + (s.auxFlowMax && s.auxFlowMax !== s.auxFlowMin ? '–' + s.auxFlowMax : '') + ' GPM aux</span>';
    if (isTr && s.engineHP) c += '<span class="cf-chip">' + s.engineHP + ' HP</span>';
    if (isTr && s.ptoHP) c += '<span class="cf-chip">' + s.ptoHP + ' PTO</span>';
    if (s.psiMax) c += '<span class="cf-chip">' + s.psiMax.toLocaleString() + ' PSI</span>';
    return c;
  }

  function collectionCategory() {
    var el = document.querySelector('[data-cf-collection-category]');
    return (el && el.getAttribute('data-cf-collection-category')) || '';
  }

  function applyFilter() {
    if (!state.specs || !state.on) return;

    var products = getProductsFromDOM();
    var cat = collectionCategory().toLowerCase();
    var compatible = [];
    var conditional = [];
    var shown = 0;

    products.forEach(function(p) {
      var v = checkCompat(p, state.specs, state.type);
      var similar = !!(p.cat && cat && (cat.indexOf(p.cat.toLowerCase()) !== -1 || p.cat.toLowerCase().indexOf(cat) !== -1));
      if (v.r === 'fail') {
        p.item.style.display = 'none';
        return;
      }
      p.verdict = v;
      p.similar = similar;
      p.item.style.display = '';
      shown++;
      if (v.r === 'pass') compatible.push(p);
      else conditional.push(p);
    });

    compatible.sort(function(a, b) { return (b.similar ? 1 : 0) - (a.similar ? 1 : 0); });
    conditional.sort(function(a, b) { return (b.similar ? 1 : 0) - (a.similar ? 1 : 0); });
    compatible.forEach(function(p) {
      p.item.style.order = p.similar ? -2 : -1;
      injectBadge(p.el, 'pass', p.similar);
    });
    conditional.forEach(function(p) {
      p.item.style.order = p.similar ? 0 : 1;
      injectBadge(p.el, 'warn', p.similar);
    });

    updateResultUI(shown, compatible.length, conditional.length, products.length, collectionCategory());
  }

  function clearFilter() {
    var badges = document.querySelectorAll('.cf-badge, .cf-similar-badge');
    for (var i = 0; i < badges.length; i++) badges[i].remove();
    var cards = document.querySelectorAll('[data-cf-product]');
    for (var j = 0; j < cards.length; j++) {
      var item = cards[j].closest('li') || cards[j];
      item.style.display = '';
      item.style.order = '';
    }
    updateResultUI(0, 0, 0, 0, '', true);
  }

  function injectBadge(cardEl, verdict, isSimilar) {
    var existing = cardEl.querySelectorAll('.cf-badge, .cf-similar-badge');
    for (var i = 0; i < existing.length; i++) existing[i].remove();
    var imgWrap = cardEl.querySelector('.card__media') || cardEl.querySelector('.product-card__media') || cardEl.firstElementChild;
    if (!imgWrap) return;
    imgWrap.style.position = 'relative';
    var badge = document.createElement('span');
    badge.className = 'cf-badge ' + verdict;
    badge.textContent = verdict === 'pass' ? '✓ Fits' : '⚠ Check';
    imgWrap.appendChild(badge);
    if (isSimilar) {
      var sim = document.createElement('span');
      sim.className = 'cf-similar-badge';
      sim.textContent = 'Similar';
      imgWrap.appendChild(sim);
    }
  }

  function updateResultUI(fit, pass, warn, total, category, clearing) {
    var res = document.getElementById('cf-result');
    var resMob = document.getElementById('cf-mob-result');
    var ban = document.getElementById('cf-banner');
    var banTxt = document.getElementById('cf-banner-text');
    if (clearing) {
      if (res) { res.classList.remove('show'); res.innerHTML = ''; }
      if (resMob) { resMob.classList.remove('show'); resMob.innerHTML = ''; }
      if (ban) ban.classList.remove('show');
      return;
    }
    var html = '<strong>' + fit + '</strong> of ' + total + ' fit — <strong>' + pass + '</strong> direct, <strong>' + warn + '</strong> conditional';
    if (res && fit >= 0) { res.innerHTML = html; res.classList.add('show'); }
    if (resMob && fit >= 0) { resMob.innerHTML = html; resMob.classList.add('show'); }
    if (ban && banTxt && fit > 0) {
      banTxt.innerHTML = '<strong>' + fit + '</strong> attachments fit your <strong>' + state.name + '</strong>' + (category ? ' — ' + category + ' shown first' : '');
      ban.classList.add('show');
    } else if (ban && fit === 0) {
      ban.classList.remove('show');
    }
    var barSub = document.getElementById('cf-bar-sub');
    if (barSub && state.on && fit > 0) {
      barSub.textContent = fit + ' compatible attachments';
      barSub.classList.add('active');
    } else if (barSub && state.name) {
      barSub.textContent = state.name;
      barSub.classList.remove('active');
    }
  }

  function els(prefix) {
    return {
      type: document.getElementById(prefix + '-type'),
      make: document.getElementById(prefix + '-make'),
      model: document.getElementById(prefix + '-model'),
      toggle: document.getElementById(prefix + '-toggle'),
      clear: document.getElementById(prefix + '-clear'),
      machine: document.getElementById(prefix + '-machine'),
      machName: document.getElementById(prefix + '-machine-name'),
      machChips: document.getElementById(prefix + '-machine-chips'),
      toggleWrap: document.getElementById(prefix + '-toggle-wrap'),
      hint: document.getElementById(prefix + '-hint')
    };
  }

  function showMachineUI() {
    ['cf', 'cf-mob'].forEach(function(prefix) {
      var e = els(prefix);
      if (e.machName) e.machName.textContent = state.name;
      if (e.machChips) e.machChips.innerHTML = machineChipsHTML(state.specs, state.type);
      if (e.machine) e.machine.classList.add('show');
      if (e.clear) e.clear.classList.add('show');
    });
    var doneBtn = document.getElementById('cf-sheet-done');
    if (doneBtn) doneBtn.classList.add('show');
    var barSub = document.getElementById('cf-bar-sub');
    if (barSub) { barSub.textContent = state.name; barSub.classList.remove('active'); }
  }

  function hideMachineUI() {
    ['cf', 'cf-mob'].forEach(function(prefix) {
      var e = els(prefix);
      if (e.machine) e.machine.classList.remove('show');
    });
  }

  function lockToggle() {
    ['cf', 'cf-mob'].forEach(function(prefix) {
      var e = els(prefix);
      if (e.toggle) { e.toggle.disabled = true; e.toggle.checked = false; }
      if (e.toggleWrap) e.toggleWrap.classList.add('is-locked');
      if (e.hint) e.hint.textContent = 'Select a machine first';
    });
    state.on = false;
  }

  function unlockToggle() {
    ['cf', 'cf-mob'].forEach(function(prefix) {
      var e = els(prefix);
      if (e.toggle) e.toggle.disabled = false;
      if (e.toggleWrap) e.toggleWrap.classList.remove('is-locked');
      if (e.hint) e.hint.textContent = 'Hides attachments that don’t fit';
    });
  }

  function syncDropdowns() {
    ['cf', 'cf-mob'].forEach(function(prefix) {
      var e = els(prefix);
      if (!e.type) return;
      e.type.value = state.type || '';
      populateMakes(state.type, e.make);
      if (state.type) setDisabled(e.make, false); else setDisabled(e.make, true);
      if (state.make) e.make.value = state.make;
      populateModels(state.type, state.make, e.model);
      if (state.make) setDisabled(e.model, false); else setDisabled(e.model, true);
      if (state.model) e.model.value = state.model;
    });
  }

  function onTypeChange(value) {
    state.type = value || null;
    state.make = state.model = state.specs = state.name = null;
    syncDropdowns();
    hideMachineUI();
    lockToggle();
    clearFilter();
  }

  function onMakeChange(value) {
    state.make = value || null;
    state.model = state.specs = state.name = null;
    syncDropdowns();
    hideMachineUI();
    lockToggle();
    clearFilter();
  }

  function onModelChange(value) {
    state.model = value || null;
    if (!state.model) {
      hideMachineUI();
      lockToggle();
      return;
    }
    state.specs = lookupSpecs(state.type, state.make, state.model);
    state.name = state.make + ' ' + state.model;
    if (!state.specs) {
      hideMachineUI();
      lockToggle();
      return;
    }
    showMachineUI();
    unlockToggle();
    saveState();
    if (state.on) applyFilter();
  }

  function wireControls(prefix) {
    var e = els(prefix);
    if (!e.type) return;
    e.type.addEventListener('change', function() { onTypeChange(this.value); });
    e.make.addEventListener('change', function() { onMakeChange(this.value); });
    e.model.addEventListener('change', function() { onModelChange(this.value); });
    if (e.toggle) {
      e.toggle.addEventListener('change', function() {
        state.on = this.checked;
        var otherId = prefix === 'cf' ? 'cf-mob-toggle' : 'cf-toggle';
        var other = document.getElementById(otherId);
        if (other && other.checked !== this.checked) other.checked = this.checked;
        if (this.checked && state.specs) applyFilter();
        else clearFilter();
      });
    }
    if (e.clear) {
      e.clear.addEventListener('click', function() {
        state.type = state.make = state.model = state.specs = state.name = null;
        state.on = false;
        syncDropdowns();
        hideMachineUI();
        lockToggle();
        ['cf', 'cf-mob'].forEach(function(p) {
          var c = els(p).clear;
          if (c) c.classList.remove('show');
        });
        clearState();
        clearFilter();
        var barSub = document.getElementById('cf-bar-sub');
        if (barSub) { barSub.textContent = 'Find compatible attachments'; barSub.classList.remove('active'); }
        var doneBtn = document.getElementById('cf-sheet-done');
        if (doneBtn) doneBtn.classList.remove('show');
      });
    }
  }

  function restoreSaved() {
    var saved = loadState();
    if (!saved || !saved.type || typeof MACHINES === 'undefined' || !MACHINES[saved.type]) return;
    state.type = saved.type;
    state.make = saved.make;
    state.model = saved.model;
    state.flow = saved.flow || 'standard';
    state.specs = lookupSpecs(saved.type, saved.make, saved.model);
    state.name = saved.make && saved.model ? saved.make + ' ' + saved.model : null;
    syncDropdowns();
    if (state.specs) {
      showMachineUI();
      unlockToggle();
    }
  }

  function viewMatches(e) {
    if (e && e.preventDefault) e.preventDefault();
    if (e && e.stopPropagation) e.stopPropagation();
    if (!state.specs) return;
    state.on = true;
    var dt = document.getElementById('cf-toggle');
    var mt = document.getElementById('cf-mob-toggle');
    if (dt && !dt.disabled) dt.checked = true;
    if (mt && !mt.disabled) mt.checked = true;
    applyFilter();
    closeDesktopDialog();
    closeMobileSheet();
    var results = document.getElementById('filter-results');
    if (results && results.scrollIntoView) results.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function wireViewMatches() {
    var viewBtns = document.querySelectorAll('.cf-view');
    for (var i = 0; i < viewBtns.length; i++) {
      viewBtns[i].addEventListener('click', viewMatches);
    }
  }

  function wireDesktopDialog() {
    var launch = document.getElementById('cf-launch');
    var dialog = document.getElementById('cf-dialog');
    var overlay = document.getElementById('cf-desk-overlay');
    var closeBtn = document.getElementById('cf-dialog-close');
    if (!launch || !dialog) return;

    function isDesktop() { return window.matchMedia('(min-width: 768px)').matches; }
    function openDialog() {
      if (!isDesktop()) return;
      if (overlay && overlay.parentElement !== document.body) document.body.appendChild(overlay);
      if (dialog.parentElement !== document.body) document.body.appendChild(dialog);
      dialog.hidden = false;
      dialog.classList.add('is-open');
      if (overlay) { overlay.hidden = false; overlay.classList.add('is-open'); }
      launch.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDialog() {
      dialog.classList.remove('is-open');
      dialog.hidden = true;
      if (overlay) { overlay.classList.remove('is-open'); overlay.hidden = true; }
      launch.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    closeDesktopDialog = closeDialog;
    launch.addEventListener('click', function() {
      if (dialog.classList.contains('is-open')) closeDialog();
      else openDialog();
    });
    if (overlay) overlay.addEventListener('click', closeDialog);
    if (closeBtn) closeBtn.addEventListener('click', closeDialog);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && dialog.classList.contains('is-open')) closeDialog();
    });
  }

  function wireMobileSheet() {
    var bar = document.getElementById('cf-bar');
    var overlay = document.getElementById('cf-overlay');
    var sheet = document.getElementById('cf-sheet');
    var close = document.getElementById('cf-sheet-close');
    var done = document.getElementById('cf-sheet-done');
    if (!bar || !sheet) return;

    function openSheet() {
      if (overlay && overlay.parentElement !== document.body) document.body.appendChild(overlay);
      if (sheet.parentElement !== document.body) document.body.appendChild(sheet);
      if (overlay) overlay.classList.add('show');
      sheet.classList.add('is-open');
      bar.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeSheet() {
      if (overlay) overlay.classList.remove('show');
      sheet.classList.remove('is-open');
      bar.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    closeMobileSheet = closeSheet;

    bar.addEventListener('click', openSheet);
    if (overlay) overlay.addEventListener('click', closeSheet);
    if (close) close.addEventListener('click', closeSheet);
    if (done) {
      done.addEventListener('click', viewMatches);
    }
  }

  function wireBanner() {
    var clearBtn = document.getElementById('cf-banner-clear');
    if (!clearBtn) return;
    clearBtn.addEventListener('click', function() {
      var dt = document.getElementById('cf-toggle');
      var mt = document.getElementById('cf-mob-toggle');
      if (dt) { dt.checked = false; dt.dispatchEvent(new Event('change')); }
      if (mt) { mt.checked = false; }
    });
  }

  function watchGrid() {
    var grid = document.querySelector('.main-products-grid__results ul, custom-pagination ul');
    if (!grid || typeof MutationObserver === 'undefined') return;
    var t = null;
    new MutationObserver(function() {
      if (!state.on) return;
      clearTimeout(t);
      t = setTimeout(applyFilter, 80);
    }).observe(grid, { childList: true, subtree: true });
  }

  function neutralizeCompareOverlap() {
    var compares = document.querySelectorAll('.products-toolbar--compare-shift-xs .products-toolbar__compare');
    for (var i = 0; i < compares.length; i++) {
      compares[i].style.position = 'static';
      compares[i].style.top = 'auto';
      compares[i].style.transform = 'none';
    }
  }

  function init() {
    neutralizeCompareOverlap();
    wireDesktopDialog();
    wireMobileSheet();
    wireViewMatches();
    if (typeof MACHINES === 'undefined' || typeof evaluateAttachmentCompat !== 'function') {
      setTimeout(initData, 50);
      return;
    }
    initData();
  }

  var dataWired = false;
  function initData() {
    if (dataWired) return;
    if (typeof MACHINES === 'undefined' || typeof evaluateAttachmentCompat !== 'function') {
      setTimeout(initData, 50);
      return;
    }
    dataWired = true;
    wireControls('cf');
    wireControls('cf-mob');
    wireBanner();
    restoreSaved();
    watchGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
